export default "__VITE_ASSET__CQtMHwA$__"